import axios from 'axios';

export const getEventBootstrap = (cacheKeyBase, cacheKeyId) => axios({
    url: `${process.env.REACT_APP_API_HOST}/event/${cacheKeyId}`,
    method: 'GET',
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
}).then(response => response.data.data)

export const getEventPresentations = (cacheKeyBase, cacheKeyId) => axios({
    url: `${process.env.REACT_APP_API_HOST}/event/${cacheKeyId}/presentations`,
    method: 'GET',
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
}).then(response => response.data.data)

export const getPresentation = (cacheKeyBase, cacheKeyId) => {
    return axios({
        url: `${process.env.REACT_APP_API_HOST}/presentation/${cacheKeyId}`,
        method: 'GET',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}` || ""
        }
    }).then(response => response.data.data)
}

export const putPresentation = ({ _id, presentation }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/presentation/${_id}`,
    method: 'PATCH',
    data: presentation,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
}).then(response => response.data.data);

export const postPresentation = ({ presentation }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/presentation`,
    method: 'POST',
    data: presentation,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }, 
}).then(response => response.data.data);

export const deletePresentation = ({ _id }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/presentation/${_id}`,
    method: 'DELETE',
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
}).then(response => response.data.data);

export const putPresentationFile = ({ _id, presentation }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/presentation/${_id}/addPresentation`,
    method: 'PATCH',
    data: presentation,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
}).then(response => response.data.data);

export const deletePresentationFile = ({ _id, presentation }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/presentation/${_id}/deletePresentation`,
    method: 'PATCH',
    data: presentation,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
}).then(response => response.data.data);

export const batchPostPresentation = ({ event_id, presentations, purchase }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/presentation-batch`,
    method: 'POST',
    data: {
        event_id, presentations, purchase,
    },
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }, 
}).then(response => response.data.data);

export const deletePresentationWithoutPpt = ({ event_id }) => axios({
    url: `${process.env.REACT_APP_API_HOST}/presentation-cleanup-non-ppt`,
    method: 'DELETE',
    data: {
        event_id
    },
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }, 
}).then(response => response.data.data);